import siteMessage from "@insite/client-framework/SiteMessage";

const getInvalidFieldMessage = (fieldLabel: string) => {
    return fieldLabel ? siteMessage("Field_Invalid", fieldLabel).toString() : "";
};

export default getInvalidFieldMessage;
